import { ProgressBar } from 'react-bootstrap';
import '../../../assets/scss/Stepper.scss';

type RegisterStepperProps = {
  step: number;
};
const RegisterStepper = (props: RegisterStepperProps) => {
  return (
    <>
      <div className="steps">
        <div className="step-item">
          <div
            className={
              props.step >= 0
                ? ' p-0 step-button text-center collapsed done'
                : ' p-0 step-button text-center collapsed '
            }
          >
            1
          </div>
        </div>
        <div className="step-item">
          <div
            className={
              props.step >= 1
                ? ' p-0 step-button text-center collapsed done'
                : ' p-0 step-button text-center collapsed '
            }
          >
            {props.step >= 1 ? '2' : ''}
          </div>
        </div>
        <div className="step-item">
          <div
            className={
              props.step >= 2
                ? ' p-0 step-button text-center collapsed done'
                : ' p-0 step-button text-center collapsed '
            }
          >
            {props.step >= 2 ? '3' : ''}
          </div>
        </div>
        <ProgressBar id="progress" max={2} now={props.step} />
      </div>
    </>
  );
};
export default RegisterStepper;
